import "../App.css";
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export const Header = (props) => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <Link className="navbar-brand text-primary logo-text" to="/todo-react/">
            <h2>{props.title}</h2>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link hover-bold active"
                  aria-current="page"
                  to="/todo-react/"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active hover-bold" to="/about">
                  About
                </Link>
              </li>
            </ul>
            {props.searchBar ? (
              <form className="d-flex">
                <input
                  className="form-control me-2"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <button className="btn btn-outline-primary" type="submit">
                  Search
                </button>
              </form>
            ) : (
              ""
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

Header.defaultProps = {
  title: "Your Title here",
  searchBar: true,
};
Header.propTypes = {
  title: PropTypes.string,
  searchBar: PropTypes.bool,
};
